import {http} from './config';
export default{
    listarOpcions:()=>{
        return http.get('api/opcions');
    },
    save:(opcion)=>{
        return http.post('api/opcion',opcion)
    },
    delete:(opcion)=>{
        return http.delete('api/opcion/'+opcion.id)
    },
    update:(opcion)=>{

            return http({method:'PUT', url:('/api/opcion/'+opcion.id), data:opcion})
    }
}
